import { Suspense } from 'react';
import { LogOut } from 'lucide-react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Avatar } from '@/components/ui';
import { useAuth } from '@/lib/auth';
import { useI18n } from '@/lib/i18n';
import logoUrl from '@/assets/suzuki-logo.png';
import { RouteLoadingFallback } from './route-loading-fallback';

export function PortalShell() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { t } = useI18n();

  async function signOut() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="flex min-h-screen flex-col bg-surface-hover">
      <header>
        <div className="h-1 bg-brand-700" />
        <div className="flex h-14 items-center justify-between border-b bg-surface px-6">
          <button type="button" className="flex items-center gap-3" onClick={() => navigate('/portal')}>
            <img src={logoUrl} alt="Suzuki" className="h-8" />
            <span className="text-lg font-semibold text-ink">{t('tp.portal.brand')}</span>
          </button>
          <div className="flex items-center gap-3 text-sm text-ink-muted">
            <span className="flex items-center gap-2"><Avatar name={user?.name || t('tp.portal.customer')} id={user?.id} size="xs" />{user?.name || t('tp.portal.customer')}</span>
            <button type="button" onClick={() => void signOut()} className="flex items-center gap-1 rounded-md px-2 py-1 hover:bg-surface-subtle" aria-label={t('shell.signOut')}>
              <LogOut className="h-4 w-4" aria-hidden="true" /> {t('shell.signOut')}
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto p-6" id="main-content">
        <Suspense fallback={<RouteLoadingFallback />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
